import { Component, OnDestroy, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { finalize, take, takeUntil, tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopService } from 'src/app/shared/api/shop.service';
import { formatDate, formatDateRitiro } from 'src/app/shared/helpers/formatDate';
import { FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { StoreService } from 'src/app/shared/services/store.service';
import { PriceArticoloService } from 'src/app/shared/services/custom/price-articolo.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Sconto, isAvailable } from 'src/app/shared/interfaces/custom/sconto';
import { ToastrService } from 'ngx-toastr';
import { ERROR_GIACENZA_CODE, handleGiacenzaError } from 'src/app/shared/helpers/giacenza_error_handler';
import { AnalyticsService } from 'src/app/shared/services/analytics.service.';
import { Livello } from 'src/app/shared/interfaces/custom/componibili';
import { getTipoSpedizioneStr } from 'src/app/shared/interfaces/custom/spedizione';
import { scontoValoreAssoluto } from 'src/app/shared/interfaces/custom/sconto';
import { CartService } from 'src/app/shared/services/cart.service';
import { RootService } from 'src/app/shared/services/root.service';
import { PayStripeComponent } from 'src/app/modules/shop/components/pay-stripe/pay-stripe.component';

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

@Component({
    selector: 'app-restaurantcheckout',
  templateUrl: './restaurantcheckout.component.html',
  styleUrls: ['./restaurantcheckout.component.scss']
})
export class RestaurantcheckoutComponent implements OnInit, OnDestroy {
    private destroy$: Subject<void> = new Subject();

    @ViewChild('modal', { read: TemplateRef }) template: TemplateRef<any>;

    controlPayMethod = new FormControl(null, Validators.required);
    controlFatturaRequired;

    checkingCodiceSconto;
    controlCodiceSconto = new FormControl();

    b2b;

    availableCoupons : Sconto[];

    constructor(
        public root: RootService,
        public cart: CartService,
        private route: ActivatedRoute,
        private router: Router,
        private shop: ShopService,
        public store: StoreService,
        private modalService: BsModalService,
        public priceArticolo: PriceArticoloService,
        private toastr: ToastrService,
        private analytics : AnalyticsService
    ) {
        if (this.store.price == 'b2b') {
            this.b2b = true;
        }

        let fatturaInclusa = false;
        if (this.store.price == 'b2b') {
            fatturaInclusa = true;
        }
        this.controlFatturaRequired = new FormControl(fatturaInclusa);

        this.shop.getAvailableCoupons(this.cart.subtotal).subscribe((r:Sconto[]) => {
            r.sort((a, b) => {
                let diff = Number(isAvailable(b, this.cart.subtotal)) - Number(isAvailable(a, this.cart.subtotal));
                if (!diff)
                    return scontoValoreAssoluto(b, this.cart.subtotal) - scontoValoreAssoluto(a, this.cart.subtotal);
                return diff;
            })
            this.availableCoupons = r;
        });
    }

    onCouponSelected(coupon : Sconto) {
        this.applyCoupon(coupon, true);
        this.controlCodiceSconto.reset();
    }

    onDiscountEnd(coupon : Sconto) {
        this.availableCoupons = this.availableCoupons.filter(c => c.codice != coupon.codice);
        if (this.cart.getCodiceSconto() == coupon.codice) {
            this.onCouponSelected(null);
        }
    }

    private applyCoupon(sconto : Sconto, showErrorInPopup?) {
        if (!sconto) {
            this.cart.setCodiceSconto(null);
            this.toastr.clear();
            this.toastr.success('Lo sconto è stato rimosso');
            return;
        }

        const down = (v, n) =>  Math.floor(v * Math.pow(10, n)) / Math.pow(10, n);
        let totalSpesa = down(this.cart.subtotal + this.cart.shippingCost, 2);
        if (sconto.indicatore_percentuale_assoluto && totalSpesa < Number(sconto.valore) + 0.01) {
            if (showErrorInPopup) {
                let valore = new Intl.NumberFormat('it', { style: 'currency', currency: 'EUR' }).format(Number(sconto.valore))
                Swal.fire({
                    text: `Importo minimo di ${valore } non raggiunto`,
                    icon: 'warning',
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: 'btn btn-primary'
                    }
                });
                return;
            }
            else {
                this.controlCodiceSconto.setErrors({
                    'greaterThanTotal': {
                        sconto: Number(sconto.valore),
                        totale: totalSpesa
                    }
                });
                return;
            }
        }
        this.cart.setCodiceSconto(sconto);
        this.controlCodiceSconto.reset();
        this.toastr.clear();
        this.toastr.success('Codice Sconto è stato applicato');
    }

    applyCode() {
        let codice = this.controlCodiceSconto.value;
        if (!codice) {
            this.controlCodiceSconto.setErrors({ 'empty': true });
            return;
        }

        this.checkingCodiceSconto = true;
        this.shop.getCodiceSconto(codice, this.cart.subtotal).subscribe(
            (sconto: Sconto) => {
                this.checkingCodiceSconto = false;
                this.applyCoupon(sconto);
            },
            err => {
                if (err.error.error_code == 3) {
                    this.controlCodiceSconto.setErrors({
                        'notValid': 'Codice sconto non esistente, scaduto o già utilizzato'
                    });
                }
                else {
                    this.controlCodiceSconto.setErrors({
                        'notValid': err.error.messaggio
                    });
                }

                this.checkingCodiceSconto = false;
            });
    }

    getModalitaDiSpedizione(modalita) {
        return getTipoSpedizioneStr(modalita);
    }

    formatDate(date) {
        return formatDate(date);
    }

    formatDateRitiro(date) {
        return formatDateRitiro(date);
    }

    metodiDiPagamento;

    getFBparams() {
        let num_items = 0;
        let value = 0;
        let contents = [];

        for (let item of this.cart.items) {
            let content = {};
            content["id"] = item["product"]["codart"];
            content["quantity"] = item.quantity;
            content["item_price"] = item.price;
            contents.push(content);
            num_items += item.quantity;
            value += item.quantity * item.price;
        }

        if (this.cart.shippingCost) {
            let content = {
                'id': `sped.${this.cart.shippingMethod.codice}`,
                'quantity': 1,
                'item_price': this.cart.shippingCost,
            }
            contents.push(content);
            num_items += 1;
            value += this.cart.shippingCost;
        }

        let params = {
            'content_type': 'product',
            'currency': 'EUR',
            'contents': contents,
            'num_items': num_items,
            'value': value,
        };

        let shippingType = this.cart.shippingMethod.tipo_spedizione

        if (shippingType == 0) {
            params['delivery_category'] = 'home_delivery';
        }
        else if (shippingType == 1) {
            params['delivery_category'] = 'in_store';
        }
        else if (shippingType == 2) {
            params['delivery_category'] = 'home_delivery';
        }
        return params;
    }

    getGAparams() {
        let value = 0;
        let contents = [];

        for (let item of this.cart.items) {
            let content = {};
            content["id"] = item["product"]["codart"];
            content["name"] = item["product"]["descart"];
            content["quantity"] = item.quantity;
            content["price"] = item.price;
            contents.push(content);
            value += item.quantity * item.price;
        }

        if (this.cart.shippingCost) {
            let content = {
                'id': `sped.${this.cart.shippingMethod.codice}`,
                'name': this.cart.shippingMethod.descrizione,
                'quantity': 1,
                'price': this.cart.shippingCost,
            }
            contents.push(content);
            value += this.cart.shippingCost;
        }

        let params = {
            'items': contents,
            'value': value,
        };
        return params;
    }

    getFBpurchaseParams(doc) {
        let num_items = 0;
        let contents = [];

        for (let item of doc.corpo) {
            let content = {};
            content["id"] = item.codiceArticolo;
            content["quantity"] = item.qta;
            content["item_price"] = Number(item.totale_riga / item.qta).toFixed(2);

            if (item.tipoRiga == 4) {
                content["id"] =`sped.${doc.codice_spedizione}`;
                if (!item.prezzo)
                    continue;
            }

            contents.push(content);
            num_items += item.qta;
        }

        let params = {
            'content_type': 'product',
            'currency': 'EUR',
            'contents': contents,
            'num_items': num_items,
            'value': doc.totaleAPagare,
        };

        let shippingType = doc.tipo_spedizione;

        if (shippingType == 0) {
            params['delivery_category'] = 'home_delivery';
        }
        else if (shippingType == 1) {
            params['delivery_category'] = 'in_store';
        }
        else if (shippingType == 2) {
            params['delivery_category'] = 'home_delivery';
        }

        return params;
    }

    getGApurchaseParams(doc) {
        let contents = [];

        for (let item of doc.corpo) {
            let content = {};
            content["id"] = item.codiceArticolo;
            content["name"] = item.descrizioneArticolo;
            content["quantity"] = item.qta;
            content["price"] = Number(item.totale_riga / item.qta).toFixed(2);

            if (item.tipoRiga == 4) {
                content["id"] =`sped.${doc.codice_spedizione}`;
                if (!item.prezzo)
                    continue;
            }

            contents.push(content);
        }

        let params = {
            'items': contents,
            'value': doc.totaleAPagare,
        };

        return params;
    }

    ngOnInit(): void {
        this.shop.getCondizioniDiPagamento().subscribe(r => {
            if (this.store.stripe_ok) {
                this.metodiDiPagamento = r;
            }
            else {
                this.metodiDiPagamento = r.filter(obj => obj.tipoPagamento != 1);
            }
        })

        let firstChangeQuantity = true;
        this.cart.quantity$.pipe(takeUntil(this.destroy$)).subscribe(quantity => {
            if (!quantity) {
                this.router.navigateByUrl('/shop/cart');
            }
            else if (firstChangeQuantity) {
                firstChangeQuantity = false;

                this.analytics.onCheckoutInit(this.cart);
            }
        });

        let firstChange = true;

        this.controlPayMethod.valueChanges.subscribe(v => {
            let found = this.metodiDiPagamento.find(obj => obj.codice == v);
            this.cart.setPaymentMethod(found);
            if (found && firstChange) {
                firstChange = false;

                this.analytics.onAddPaymentInfo(found);
            }
        });
    }

    ngOnDestroy(): void {
        this.cart.setCodiceSconto(null);
        this.cart.setPaymentMethod(null);
        this.cart.setShippingMethod(null, 0);
        this.destroy$.next();
        this.destroy$.complete();
    }

    loading;
    modalRef: BsModalRef;

    confirmOrder() {
        let metodoDiPagamentoCode = this.controlPayMethod.value;
        this.controlPayMethod.markAsTouched();
        if (!metodoDiPagamentoCode) {
            Swal.fire('Metodo di pagamento non selezionato', 'Seleziona metodo di pagamento', 'error');
            return;
        }

        let documento = this.cart.creaDocumentoPerCheckout(metodoDiPagamentoCode, this.controlFatturaRequired.value);
        if (!documento)
            return;

        let metodoDiPagamentoObj = this.metodiDiPagamento.find(obj => obj.codice == metodoDiPagamentoCode);
        if (!metodoDiPagamentoObj)
            return;

        this.controlPayMethod.disable();
        this.controlFatturaRequired.disable();

        this.loading = true;

        if (metodoDiPagamentoObj.tipoPagamento == 1) {
            this.modalRef = this.modalService.show(PayStripeComponent, {
                class: 'modal-dialog-centered modal-md',
                backdrop: 'static', keyboard: false
            });
            this.modalRef.content.documento = documento;
            this.modalRef.onHidden.subscribe(r => {
                this.controlPayMethod.enable();
                this.controlFatturaRequired.enable();
                this.loading = false;
            });
        }
        else {
            this.shop.creaOrdine(documento).pipe(tap(documento => {
                try {
                    this.analytics.onPurchaseEvent(documento);
                } catch (err) { console.error(err); }
            })).subscribe(
                r => {
                    localStorage.setItem('lastOrder', JSON.stringify(r));
                    this.router.navigate(['/shop/cart/checkout/success']);
                    timer(0).subscribe(r => {
                        this.cart.resetCart();
                    });
                },
                error => {
                    this.loading = false;
                    if (ERROR_GIACENZA_CODE.includes(error.error.error_code)) {
                        handleGiacenzaError(this.router, this.cart, this.shop);
                    }
                    else
                        alert(JSON.stringify(error));
                });
        }
    }

    getOptionLine(option) {
        let line = [];
        for (let i = 1; i <= 4; i++) {
            if (option[i]) {
                let str = "";
                let list = option[i].list;
                str += list ? list.descrizione : `Opzione ${i}`;
                str += ": ";
                let optionObj = option[i].option;
                str += optionObj.codice;
                line.push(str);
            }
        }

        return "- " + line.join(', ');
    }

    getBoxContentDescription(box_levels : Livello[]) {
        let items = [];
        for (let level of box_levels) {
            for (let item of level.items) {
                items.push(item.qta_selezionata + ' × ' + (item.articolo_componente ? item.articolo_componente.descart : item.codice_articolo_componente));
            }
        }
        return items;
    }
}
